import { useTenantMetadata } from '@globals/useTenantMetadata'
import { formatDistanceToNowStrict } from 'date-fns'
import { localeMap } from '../AppLayout'

type TimeAgoProps = {
  date: string | Date
}

const TimeAgo: React.FC<TimeAgoProps> = ({ date }) => {
  const [{ language }] = useTenantMetadata()
  return formatDistanceToNowStrict(date, {
    locale: localeMap[language],
    addSuffix: true,
  })
}

export default TimeAgo
